import { useLazyQuery } from "@apollo/client/react";
import React, { useEffect, useState } from "react";
import { CardContent, Card } from '@mui/material';

import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import '../../RIValidationSearch/components/riValidationSearch.scss';
import { adaptEquipoArray, GET_EQUIPO_BY_ID_EVALUACION } from "../../../data/graphQL/queries/ResumenIngresoValidation/getConfirmacionEquipoByIdEvaluacion";

const noRowsLabel = 'No se eligió ningún profesional para este equipo';
const InformacionEquipo = ({ isFromEvolucionAsistencial, idEvaluacion }) => {
  const [equipo, setEquipo] = useState([]);

  const [getEquipo] = useLazyQuery(GET_EQUIPO_BY_ID_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!idEvaluacion) return;
    getEquipo({
      variables: {
        idEvaluacion: idEvaluacion
      }
    }).then(({ data }) => { setEquipo(adaptEquipoArray(data)); }).
      catch((error) => {
        if (error?.name !== "AbortError") {
          console.error("Error fetching equipo:", error);
        }
      }
      );
  }, [idEvaluacion]);

  const initialColumns = [
    {
      field: 'tipoProfesional',
      headerName: 'Tipo Profesional',
      flex: 4
    },
    {
      field: 'frecuencia',
      headerName: 'Frecuencia',
      flex: 4
    },
    {
      field: 'profesional',
      headerName: 'Profesional',
      flex: 2
    }];



  const equipoColumns = generateColumnsDefaultConfiguration(initialColumns);

  return <>
    {!isFromEvolucionAsistencial && <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
      <CardContent>
        <h4>Confirmación del Equipo</h4>
        <DataGridGenerico
          rows={equipo}
          columns={equipoColumns}
          hideFooterPagination={false}
          toolbar={false}
          localeText={{ noRowsLabel }} />

      </CardContent>
    </Card>}
    {isFromEvolucionAsistencial &&
      <DataGridGenerico
        rows={equipo}
        columns={equipoColumns}
        hideFooterPagination={false}
        toolbar={false}
        localeText={{ noRowsLabel }} />

    }
  </>;
};

export default InformacionEquipo;